<template>
  <div class="EchartsDataStyle">
    <div class="p-name">数据显示风格</div>
    <div class="p-buttons">
      <el-button
        size="mini"
        @click="handleChange('default')"
        :class="{ 'active-btn': echartsDataStyle == 'default' }"
        >默认</el-button
      >
      <el-button
        size="mini"
        @click="handleChange('simple')"
        :class="{ 'active-btn': echartsDataStyle == 'simple' }"
        >简洁</el-button
      >
      <el-button
        size="mini"
        @click="handleChange('emphasis')"
        :class="{ 'active-btn': echartsDataStyle == 'emphasis' }"
        >强调</el-button
      >
    </div>
  </div>
</template>
<script>
export default {
  name: 'EchartsDataStyle',
  /*  prop属性只读 不可直接修改 会影响性能以及维护性 */
  props: {
    CurrentConfigration: Object,
    propertyData: Object,
    propertyDataKey: String,
  },
  data() {
    return {
      echartsDataStyle: 'default',
    };
  },
  created() {},
  mounted() {
    /* 获取初始值 */
    this.echartsDataStyle = this.propertyData[this.propertyDataKey].value;
  },
  methods: {
    handleChange(val) {
      this.echartsDataStyle = val;
      /* 更新数据 */
      this.$store.commit('update_PropertyData', {
        key: this.propertyDataKey,
        value: val,
      });
    },
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.EchartsDataStyle {
  width: 100%;
  box-sizing: border-box;

  .p-name {
    color: $property-title-color;
    font-size: $property-title-size;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    height: 30px;
    line-height: 30px;
  }
  .p-buttons {
    margin: 10px 0;
    box-sizing: border-box;
    padding: 0 15px;
    width: 100%;
    display: flex;
    justify-content: space-between;

    .el-button {
      box-sizing: border-box;
      text-align: center;
      font-weight: 1000;
      background: #3f4261;
      color: rgb(230, 230, 230);
      cursor: pointer;
      border: 1px solid #111;
      &:hover {
        background: linear-gradient(143deg, #335ae9, #6f6ff5);
        // color: white;
      }
      &:active {
        background: linear-gradient(143deg, #3054d8, #5151d1);
        color: white;
      }
    }
    .active-btn {
      background: linear-gradient(143deg, #3054d8, #5151d1);
      color: white;
    }
  }
}
</style>
